import { useEffect, useState } from "react"
import { useGetUsersQuery } from "./usersApiSlice"
import User from './User'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import useAuth from '../../hooks/useAuth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserGear } from "@fortawesome/free-solid-svg-icons"


const UsersList = () => {
    useTitle('DPE: Users List')

    const { userId, isAdmin, isManager } = useAuth()

    // get user data for manager
    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })
    let staffMembers=null
    if (isManager) {
        // get staff members, used for managers only
        staffMembers=user.staff

        // add manager id for current users
        staffMembers= [...staffMembers, userId]
    }
    
    const {
        data: users,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUsersQuery('usersList')

    let content

    if (isLoading) content = <PulseLoader color={"#5f788a"} />

    useEffect(() => {

        if (isError) {
            toast.error(error?.data?.message);
        }

    }, [isError, error])


    // pagination: 1
    const [currentPage, setcurrentPage]= useState(1)
    const [itemsPerPage, setitemsPerPage]= useState(6)
    const updateitemsPerPage = (e) => {
        setitemsPerPage(e.target.value)
        setcurrentPage(1)
    }
    const pageSizes = [3, 6, 9, 12, 15];



    if (isSuccess) {

        const { ids, entities } = users

        let filteredIds=null
        if (isAdmin) {
            filteredIds = [...ids]
        } else if (isManager){
            filteredIds = ids.filter(userId => staffMembers.includes(entities[userId]._id))
        } else {
            toast.error('Not Authorized');
        }


        // pagination: 2
        const totalItems= filteredIds.length
        const lastIndex= currentPage * itemsPerPage
        const firstIndex= lastIndex- itemsPerPage
        const currentPageItems = filteredIds.slice(firstIndex, lastIndex)
        let lastPage =  Math.ceil(ids.length / itemsPerPage)
        const pages = []
        if (totalItems <= itemsPerPage) {
            let i=1
            pages.push(i)
            lastPage=1
        } else {
            for (let i=1 ; i < lastPage+1 ; i++){                
                pages.push(i)
            }
        }
        let prevActive= currentPage===1 ? 'page-item disabled' : 'page-item'
        let nextActive= currentPage===lastPage ? 'page-item disabled' : 'page-item'


        const tableContent = currentPageItems.map(userId => <User key={userId} userId={userId} />)

        content = (
            <section id="main_content">
                <header>
                    <div className="row">
                        <div className="col-md-8">
                            <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faUserGear} style={{fontSize:"30px", marginRight:"5px"}} />Users</h1>
                        </div>
                        <div className="col-md-4 text-end mt-3">
                            {totalItems} Users
                        </div>
                    </div>
                </header>
                <main>
                    <div className="table-responsive">
                    
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Firstname</th>
                                    <th>Lastname</th>
                                    <th>Active</th>
                                    <th>Roles</th>
                                    <th>Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableContent}
                            </tbody>
                        </table>

                        <div className="row g-0">
                            <div className="col-md-8">
                                <ul className="pagination">
                                    <li className={prevActive}>
                                        <span className="page-link" role="button" onClick={() => setcurrentPage(currentPage-1)}>Previous</span>
                                    </li>
                                    {
                                        pages.map((page, index) =>{
                                            let clsName = currentPage-1===index ? 'page-item active' : "page-item"
                                            return(
                                                <li key={index} className = {clsName}>
                                                    <span className="page-link" role="button" onClick={() => setcurrentPage(page)}>{page}</span>
                                                </li>
                                            )
                                        })
                                    }
                                    <li className={nextActive}>
                                        <span className="page-link" role="button" onClick={() => setcurrentPage(currentPage+1)}>Next</span>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-3 text-end mt-2">
                                <label  style={{marginRight:"10px"}}>Users per page</label>
                            </div>
                            <div className="col-md-1">
                                <select name="itemsPerPage" id="itemsPerPage" className="form-control  text-end" 
                                    value={itemsPerPage} 
                                    onChange={updateitemsPerPage}>
                                    {pageSizes.map((option, index) => {
                                    return (
                                        <option key={index}>
                                            {option}
                                        </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>

                    </div>
                    
                </main>
            </section>
        )
    }

    return content
}
export default UsersList